import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const service = {
  path: '/services',
  component: Layout,
  name: 'services',
  redirect: '/services/index',
  children: [
    // {
    //   path: '/services/index',
    //   component: () => import('@/views/service/index'),
    //   name: 'services.index',
    //   meta: { title: 'Услуги'}
    // },
    {
      path: '/services/priceList',
      component: () => import('@/views/service/priceList'),
      name: 'services.priceList',
      meta: { title: i18n.t(`message.price_list`)}
    }
  ]
}

export default service